/**
 * Creates a slugged URL for our purposes.
 * @param {*} toSlug - Movie title
 */
const createSlug = toSlug => {
    return toSlug
        .toLowerCase()
        .replace(/[^\w\s-]/g, "") // remove non-word [a-z0-9_], non-whitespace, non-hyphen characters
        .replace(/[\s_-]+/g, "-") // swap any length of whitespace, underscore, hyphen characters with a single -
        .replace(/^-+|-+$/g, ""); // remove leading, trailing -
};

module.exports = {
    createSlug
};



// WEBPACK FOOTER //
// ./src/libraries/Interiors.js